import { useRoute } from 'vue-router';

export const usePageTitle = () => {
  return useRoute().meta.title;
};
